"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchBusinessEvent = dispatchBusinessEvent;
var _createCustomEvent = require("./createCustomEvent");
var _dispatchCustomEvent = require("./dispatchCustomEvent");
/**
 * Dispatches a business event with the specified name and data.
 * @param name The specific name of the business event.
 * @param data The data associated with the business event.
 * @param eventTarget The target to dispatch the event on. Defaults to `window`.
 */
function dispatchBusinessEvent(name, data, eventTarget = window) {
  (0, _dispatchCustomEvent.dispatchCustomEvent)((0, _createCustomEvent.createCustomEvent)(name, data), eventTarget);
}
//# sourceMappingURL=dispatchBusinessEvent.js.map